/**
 * A duration as `m:ss` in Latin digits — the design's rule for time codes
 * (docs/design-system.md, "قاعدهٔ اعداد"): a duration is read off a player,
 * not counted, so it keeps Western digits like the phone number and the
 * playback speed do. Mirrors `Numerals.audioClock` in the Android app.
 */
export function clock(totalSeconds) {
  const whole = Math.max(0, Math.floor(Number(totalSeconds) || 0))
  const minutes = Math.floor(whole / 60)
  const seconds = whole % 60
  return `${minutes}:${String(seconds).padStart(2, '0')}`
}
